var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-checkbox',{attrs:{"disabled":_vm.disabled,"data-cy":`${_vm.attributeName}-checkbox`,"false-value":false,"label":_vm.helpText,"rules":_vm.ruleList,"true-value":true,"type":"boolean"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }